import PropTypes from 'prop-types';
import React from 'react';

import ClipboardCopy from '@components/common/clipboard_copy/main';
import { DialogSizes, StandardDialog } from '@components/library/dialog';

import './styles/share_pin_modal.scss';

const SharePinModal = ({ onClose, open, pinLabel, shareUrl }) => (
  <StandardDialog
    dialogBodyClassName="spm__body"
    dialogClassName="spm"
    dialogHeaderClassName="spm__header"
    dialogInnerClassName="spm__inner"
    onClose={onClose}
    open={open}
    showClose
    showFooter={false}
    size={DialogSizes.Medium}
    title="Share Search"
    titleIcon="bff-share"
  >
    <div className="spm__content">
      <p className="spm__description">
        Send the link below to someone and they will see this Brandfolder initially filtered for&nbsp;
        <strong className="spm__pin-name">{pinLabel}</strong>
      </p>
      <label className="spm__label" htmlFor="share-pin-url">
        Share link URL
      </label>
      <div className="spm__url-row">
        <input
          className="spm__url-input brandfolder-input"
          id="share-pin-url"
          readOnly
          value={shareUrl}
        />
        <ClipboardCopy textToCopy={shareUrl}>
          <button className="spm__copy-btn" type="button">Copy</button>
        </ClipboardCopy>
      </div>
      <a
        className="spm__new-tab-link"
        href={shareUrl}
        rel="noopener noreferrer"
        target="_blank"
      >
        Open in new tab
      </a>
    </div>
  </StandardDialog>
);

SharePinModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  pinLabel: PropTypes.string.isRequired,
  shareUrl: PropTypes.string.isRequired,
};

export default SharePinModal;
